var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bi-setting-reportToPush-wrap" },
    [
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(
          _vm._s(_vm.$t("menu::system-setting::param-setting::report-to-push"))
        ),
      ]),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c(
              "div",
              { staticClass: "header" },
              [
                _c("span", [_vm._v("日报推送")]),
                _c("el-switch", {
                  staticStyle: { "margin-left": "16px" },
                  on: {
                    change: function ($event) {
                      return _vm.onSubmit("status")
                    },
                  },
                  model: {
                    value: _vm.params.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "status", $$v)
                    },
                    expression: "params.status",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "tip-info" }, [
              _vm._v(
                " 开启后系统将通过“超店shoplus“微信公众号，定时发送经营日报至您的微信，及时掌握经营状况 "
              ),
            ]),
          ]),
          _c(
            "div",
            { staticStyle: { "min-height": "720px" } },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.params.status,
                      expression: "params.status",
                    },
                  ],
                  staticClass: "cell-content",
                },
                [
                  _c("div", { staticClass: "card-box" }, [
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "label-item mb-16" }, [
                        _vm._v("定时发送"),
                      ]),
                      _c(
                        "span",
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "12px" } },
                            [_vm._v("每天")]
                          ),
                          _c("el-time-select", {
                            staticClass: "time-pick input-select",
                            attrs: {
                              "picker-options": {
                                start: "00:00",
                                step: "00:30",
                                end: "23:30",
                              },
                            },
                            model: {
                              value: _vm.params.sendTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "sendTime", $$v)
                              },
                              expression: "params.sendTime",
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticClass: "input-select select-item ml-12",
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.params.sendDay,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "sendDay", $$v)
                                },
                                expression: "params.sendDay",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c(
                        "span",
                        { staticClass: "label-item mb-16" },
                        [
                          _c("span", [_vm._v("推送对象")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: { effect: "dark", placement: "top-start" },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    " 接收推送需关注并绑定shoplus微信公众号，请使用微信关注“超店Shoplus”并绑定您的账号 "
                                  ),
                                ]
                              ),
                              _c("i", {
                                staticClass:
                                  "iconfont icona-01wenhao3 push-tooltip ml-8",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("span", [_vm._v("全部含经营日报看板查看权限的用户")]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "label-item mb-16" }, [
                        _vm._v("发送内容"),
                      ]),
                      _c(
                        "span",
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "0" },
                              model: {
                                value: _vm.params.sendTemplate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "sendTemplate", $$v)
                                },
                                expression: "params.sendTemplate",
                              },
                            },
                            [_vm._v("当日经营概况")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "1" },
                              model: {
                                value: _vm.params.sendTemplate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "sendTemplate", $$v)
                                },
                                expression: "params.sendTemplate",
                              },
                            },
                            [_vm._v("环比经营概况")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "example" },
                        [
                          _c("div", { staticClass: "example-title" }, [
                            _vm._v("公众号推送预览"),
                          ]),
                          _c("el-image", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.params.sendTemplate == 0,
                                expression: "params.sendTemplate == 0",
                              },
                            ],
                            staticClass: "example-img",
                            attrs: { src: _vm.img1 },
                          }),
                          _c("el-image", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.params.sendTemplate == 1,
                                expression: "params.sendTemplate == 1",
                              },
                            ],
                            staticClass: "example-img",
                            attrs: { src: _vm.img2 },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.params.status,
                      expression: "params.status",
                    },
                  ],
                  staticClass: "btn-wrap",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.saveLoading, type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }